import { render, staticRenderFns } from "./advertisingLocation.vue?vue&type=template&id=9a987cb8&scoped=true&"
import script from "./advertisingLocation.vue?vue&type=script&lang=js&"
export * from "./advertisingLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a987cb8",
  null
  
)

export default component.exports